// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog-image-hover {
  transition: transform 0.4s ease;
  cursor: pointer;
}

.blogcard {
  max-width: 900px;
  margin: 0 auto;
}

.blog-image-hover:hover {
  transform: scale(1.05);
}

/* blogdetails.css */
@media (max-width: 768px) {
  .blog-description {
    font-size: 0.95rem;
    line-height: 1.6;
  }

  .blogcard {
    padding: 0 !important;
  }

  .heading h2 {
    font-size: 1.5rem;
  }
}

@media (min-width: 992px) and (max-width: 1200px) {
  .blog-feature-image {
    max-width: 75%;
    /* Adjust this percentage as needed */
    display: block;
    margin: 0 auto;
  }
}

@media (max-width: 991px) {
  .blog-feature-image {
    width: 100%;
  }
}

@media (min-width: 1201px) {
  .blog-feature-image {
    max-width: 100%;
  }
}

@media(max-width: 575.98px){
  .blogcard{
    padding: 0px 20px!important;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/blogdetails.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,cAAc;IACd,qCAAqC;IACrC,cAAc;IACd,cAAc;EAChB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".blog-image-hover {\n  transition: transform 0.4s ease;\n  cursor: pointer;\n}\n\n.blogcard {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.blog-image-hover:hover {\n  transform: scale(1.05);\n}\n\n/* blogdetails.css */\n@media (max-width: 768px) {\n  .blog-description {\n    font-size: 0.95rem;\n    line-height: 1.6;\n  }\n\n  .blogcard {\n    padding: 0 !important;\n  }\n\n  .heading h2 {\n    font-size: 1.5rem;\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1200px) {\n  .blog-feature-image {\n    max-width: 75%;\n    /* Adjust this percentage as needed */\n    display: block;\n    margin: 0 auto;\n  }\n}\n\n@media (max-width: 991px) {\n  .blog-feature-image {\n    width: 100%;\n  }\n}\n\n@media (min-width: 1201px) {\n  .blog-feature-image {\n    max-width: 100%;\n  }\n}\n\n@media(max-width: 575.98px){\n  .blogcard{\n    padding: 0px 20px!important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
